export default __webpack_public_path__ + "static/media/6A1_at_2020-15-1.a302cde3.png";